import './app.scss';

import React, {Fragment, Suspense} from 'react';
import {Redirect, Route, Router, Switch} from 'react-router-dom';

import {Header} from './header/header';
import {SearchPage} from './search/page/searchPage';
import {createBrowserHistory} from 'history';
import {Spinner} from './common/spinner/spinner';
import {LandingPage} from './landingPage/landingPage';
import {SettingsPage} from './settings/settingsPage';
import {AnalysisPage} from './analysis/analysisPage';
import {useConfigRequest} from './config/config-service';
import {useSelector} from 'react-redux';
import {PUBLIC_URL, SEARCH_PATH} from './config';
import {URL_QUERY_PARAM} from './search/const';
import {useSettingsContainerRequest} from './search/search-hooks';
import {LocalizationProvider} from './localizationUtil';
import AuthContextProvider from './auth/AuthContextProvider';

export const App = (): JSX.Element => {
    useConfigRequest();
    useSettingsContainerRequest();

    const config = useSelector((state) => state.config);
    //https://stackoverflow.com/a/47581260
    const history = createBrowserHistory({
        basename: PUBLIC_URL
    });


    if (Object.entries(config.styleVariables).length === 0) {
        return <Spinner/>;
    }
    const searchPageEnabled = config.search.enabled;
    const analysisPageEnabled = config.analysis.enabled;
    const landingPageEnabled = config.landingPage.enabled;

    function getLandingPage() {
        if (landingPageEnabled) {
            return <Route exact path="/" component={LandingPage}/>;
        } else if (searchPageEnabled) {
            return <Route exact path="/" component={SearchPage}/>;
        } else if (analysisPageEnabled) {
            return <Route exact path="/" component={AnalysisPage}/>;
        } else {
            return <div>Error: no route defined!</div>;
        }
    }

    function getUriWithQueryParams() {
        return ({match, location}) => {
            let query = match.params.query;
            const splitUriOnQuestionMark = location.search.split('?').filter((q) => q !== '');
            let queryParameters = '';

            if (splitUriOnQuestionMark.length > 1) {
                query += `?${splitUriOnQuestionMark.slice(0, -1).join('?')}`;
                queryParameters = `${splitUriOnQuestionMark[splitUriOnQuestionMark.length - 1]}`;
            }

            const combinedQueryParameters = new URLSearchParams({
                [URL_QUERY_PARAM]: query,
                ...Object.fromEntries(new URLSearchParams(`?${queryParameters}`)),
            });
            return <Redirect to={`${SEARCH_PATH}?${combinedQueryParameters.toString()}`}/>;
        };
    }

    return (
        <Suspense fallback={<Spinner/>}>
            <AuthContextProvider>
                <Router history={history}>
                    <LocalizationProvider>
                        <Fragment>
                            <Header/>
                            <div id="content">
                                <Switch>
                                    <Route exact path={SEARCH_PATH + '/:query'}
                                           render={getUriWithQueryParams()}
                                    />
                                    <Route exact path={SEARCH_PATH} component={SearchPage}/>
                                    <Route exact path="/analysis" component={AnalysisPage}/>
                                    <Route exact path="/settings" component={SettingsPage}/>
                                    {getLandingPage()}
                                </Switch>
                            </div>
                        </Fragment>
                    </LocalizationProvider>
                </Router>
            </AuthContextProvider>
        </Suspense>
    );
};

export default App;
